import { render } from "./inventoryreport.vue?vue&type=template&id=08342585&scoped=true"
import script from "./inventoryreport.vue?vue&type=script&lang=js"
export * from "./inventoryreport.vue?vue&type=script&lang=js"

import "./inventoryreport.vue?vue&type=style&index=0&id=08342585&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08342585"]])

export default __exports__